const MobileWidgets = () => {
  return (
    <div className='offcanvas-widget-area'>
      <div className='off-canvas-contact-widget'>
        <div className='header-contact-info'>
          <ul className='header-contact-info__list'>
            <li>
              <i className='fa fa-phone'></i>{' '}
              <a href='tel://12452456012'>00201223242324</a>
            </li>
            <li>
              <i className='fa fa-envelope'></i>{' '}
              <a href='mailto:info@yourdomain.com'>Service@hetoko.com</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className='off-canvas-widget-social'>
        <a
          href='https://www.facebook.com/share/1A494GD6GK/?mibextid=wwXIfr'
          title='Facebook'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fa fa-facebook'></i>
        </a>
        <a
          href='https://www.instagram.com/hetoko?igsh=MW1rN254MnEyYjJ4dw%3D%3D&utm_source=qr'
          title='Instagram'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fa fa-instagram'></i>
        </a>
        <a
          href='https://youtube.com/@hetoko?si=AFJiOHsI6NxswhCR'
          title='Youtube'
          target='_blank'
          rel='noopener noreferrer'
        >
          <i className='fa fa-youtube'></i>
        </a>
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
